module.exports = __webpack_public_path__ + "static/sessionreplaysnewpageLS-7b7d997fd08fdc0cc0254a20cad3466c.png";